// import core components
import Head from "next/head";
import { useRouter } from "next/router";

// import custom component

// import interfaces
import SeoProps from "@/interfaces/SEO";

export default function SEO({
  seo,
  yoastSeo,
  isSinglePost = false,
  suppSeoPost,
}: SeoProps) {
  const router = useRouter();

  function handleRenderingUrl() {
    if (router.asPath !== "/") {
      return process.env.NEXT_PUBLIC_WEBSITE_DOMAIN + router.asPath;
    }

    return process.env.NEXT_PUBLIC_WEBSITE_DOMAIN;
  }

  return (
    <Head>
      <title>
        {yoastSeo?.title
          ? yoastSeo?.title
          : yoastSeo?.og_title
          ? yoastSeo?.og_title
          : seo?.title}
      </title>
      {(yoastSeo || seo) &&
        (yoastSeo?.description ||
          yoastSeo?.og_description ||
          seo?.description) && (
          <meta
            name="description"
            content={
              yoastSeo?.description
                ? yoastSeo?.description
                : yoastSeo?.og_description
                ? yoastSeo?.og_description
                : seo?.description
            }
            key="description"
          />
        )}

      <meta charSet="utf-8" />

      <meta
        name="robots"
        content={
          yoastSeo?.robots
            ? `${yoastSeo?.robots.follow} index ${yoastSeo?.robots["max-image-preview"]} ${yoastSeo?.robots["max-snippet"]} ${yoastSeo?.robots["max-video-preview"]}`
            : "max-snippet:-1, max-image-preview:large, max-video-preview:-1"
        }
        key="robots"
      />

      <link rel="canonical" href={handleRenderingUrl()} key="canonical" />
      <meta
        property="og:locale"
        content={yoastSeo ? yoastSeo?.og_locale : "fr_CA"}
        key="og:locale"
      />
      <meta
        property="og:type"
        content={yoastSeo ? yoastSeo?.og_type : "website"}
        key="og:type"
      />
      <meta
        property="og:title"
        content={
          yoastSeo?.title
            ? yoastSeo?.title
            : yoastSeo?.og_title
            ? yoastSeo?.og_title
            : seo?.title
        }
        key="og:title"
      />
      {(yoastSeo?.description ||
        yoastSeo?.og_description ||
        seo?.description) && (
        <meta
          property="og:description"
          content={
            yoastSeo?.description
              ? yoastSeo?.description
              : yoastSeo?.og_description
              ? yoastSeo?.og_description
              : seo?.description
          }
          key="og:description"
        />
      )}
      <meta property="og:url" content={handleRenderingUrl()} key="og:url" />
      <meta
        property="og:site_name"
        content={
          yoastSeo
            ? yoastSeo?.og_site_name
            : process.env.NEXT_PUBLIC_WEBSITE_NAME
        }
        key="og:site_name"
      />
      <meta
        property="og:image"
        content={
          seo?.image && seo?.image.url[0]
            ? seo?.image.url[0]
            : "https://districtweb.ca/images/district-web-engage-in-your-results-share-image.jpg"
        }
        key="og:image"
      />
      <meta
        property="og:image:secure_url"
        content={
          seo?.image && seo?.image.url[0]
            ? seo?.image.url[0]
            : "https://districtweb.ca/images/district-web-engage-in-your-results-share-image.jpg"
        }
        key="og:image:secure_url"
      />
      <meta
        property="og:image:width"
        content={
          seo?.image && seo?.image.url[1] ? `${seo?.image.url[1]}px` : "1200px"
        }
        key="og:image:width"
      />
      <meta
        property="og:image:height"
        content={
          seo?.image && seo?.image.url[2] ? `${seo?.image.url[2]}px` : "630px"
        }
        key="og:image:height"
      />
      <meta
        property="og:image:type"
        content={
          yoastSeo && yoastSeo.og_image
            ? yoastSeo?.og_image[0].type
            : "image/jpg"
        }
        key="og:image:type"
      />
      <meta
        property="og:image:alt"
        content={seo?.image && seo?.image.alt ? seo?.image.alt : "District web"}
        key="og:image:alt"
      />
      <meta
        name="twitter:card"
        content={
          yoastSeo && yoastSeo.twitter_card ? yoastSeo.twitter_card : "summary"
        }
        key="twitter:card"
      />
      {(yoastSeo?.description ||
        yoastSeo?.og_description ||
        seo?.description) && (
        <meta
          name="twitter:description"
          content={
            yoastSeo?.description
              ? yoastSeo?.description
              : yoastSeo?.og_description
              ? yoastSeo?.og_description
              : seo?.description
          }
          key="twitter:description"
        />
      )}
      <meta
        name="twitter:title"
        content={
          yoastSeo?.title
            ? yoastSeo?.title
            : yoastSeo?.og_title
            ? yoastSeo?.og_title
            : seo?.title
        }
        key="twitter:title"
      />
      <meta
        name="twitter:image:src"
        content={
          seo?.image && seo?.image.url[0]
            ? seo?.image.url[0]
            : "https://districtweb.ca/images/district-web-engage-in-your-results-share-image.jpg"
        }
        key="twitter:image:src"
      />

      {isSinglePost && suppSeoPost && (
        <>
          {suppSeoPost.articleSection && (
            <meta
              property="article:section"
              content={suppSeoPost.articleSection}
              key="article:section"
            />
          )}

          {suppSeoPost.articlePublished && (
            <meta
              property="article:published"
              content={suppSeoPost.articlePublished}
              key="article:published"
            />
          )}
        </>
      )}
    </Head>
  );
}
